/** Brand logo tile (OutlierOS header placement). Shape and colour come from packages/core brand (decision 61). */
import { BRAND } from '@vw/core/src/brand';

export function BrandLogo({ size = 32 }: { size?: number }) {
  // The kit's app icon (assets/brand/svg/viralwise-icon.svg): brand tile + white filled mark.
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} className="shrink-0" aria-hidden="true">
      <rect width="64" height="64" rx={BRAND.logoTileRadius} fill={BRAND.color} />
      <path d={BRAND.logoPath} fill="#FFFFFF" />
    </svg>
  );
}
export const BRAND_NAME = BRAND.name;
export const BRAND_TAGLINE = BRAND.tagline;
